import { format } from "date-fns";
import api from "../services/api";

interface IPartialResponse {
    codeResult: string;
    data: any[];
}

export interface IPartialMonthParams {
    year: string;
    month: string;
    regionalId: string;
    sectorId: string;
    agentId: string;
    tipo: string;
    comVendas: string;

}
export interface IPartialMonth {
    regional: string;
    setor: string;
    representante: string;
    quantidade: number;
    totalVendas: number;
    totalReceber: number;
    totalRecebido: number;
    credDeb: number;
    empresa: number;
    faltam: number;
}


class PartialRepository {
    public async PartialMonth({ year, month, regionalId, sectorId, agentId, tipo, comVendas }: IPartialMonthParams): Promise<IPartialMonth[]> {
        const initialDate = format(new Date(parseInt(year), parseInt(month) - 1, 1, 0, 0, 0), "yyyy-MM-dd HH:mm:ss");
        const endDate = format(new Date(parseInt(year), parseInt(month), 1, 0, 0, 0), "yyyy-MM-dd HH:mm:ss");

        const body = {
            "tables": ["Conference", "Representante", "GerenteSetor", "GerenteRegional", "Kit", "Pedido"],
            "sql": [
                {
                    "coderesult": "Parcial",
                    "query": `SELECT GerenteRegional.nome as Regional, 
                    GerenteSetor.nome as Setor, 
                    Representante.nome as Representante, 
                    COUNT(Conference.kitId) as Qtd, 
                    SUM(Conference.valorVendido) as TotalVendas, 
                    SUM(Conference.valorReceber) as TotalReceber, 
                    SUM(Conference.valorRecebido) as TotalRecebido, 
                    (SUM(Conference.valorRecebido) - SUM(Conference.valorReceber)) as CredDeb, 
                    (SUM(Conference.valorRecebido) - SUM(Conference.comissaoRepresentante)) as Empresa 
                    FROM Conference 
                    INNER JOIN Representante 
                    ON Representante.id = Conference.representanteId 
                    INNER JOIN GerenteSetor 
                    ON GerenteSetor.id = Representante.gerenteSetorId 
                    INNER JOIN GerenteRegional 
                    ON GerenteRegional.id = GerenteSetor.gerenteRegionalId 
                    INNER JOIN Kit 
                    ON Kit.id = Conference.kitId 
                    WHERE Conference.data >= "${initialDate}" 
                    AND Conference.data < "${endDate}" 
                    AND Conference.conferenceType = 0 
                    AND Kit.tipo IN(${tipo})
                    ${comVendas != "AMBOS" ? `AND Conference.valorVendido ${comVendas} ` : ""}
                    ${regionalId.length > 0 ? `AND GerenteRegional.id = '${regionalId}' ` : ""}
                    ${sectorId.length > 0 ? `AND GerenteSetor.id = '${sectorId}' ` : ""}
                    ${agentId.length > 0 ? `AND Representante.id = '${agentId}' ` : ""}
                    GROUP BY GerenteRegional.nome, GerenteSetor.nome, Representante.nome 
                    ORDER BY Regional, Setor, Representante`
                },
                {
                    "coderesult": "Faltam",
                    "query": `SELECT COUNT(Kit.id) as Faltam 
                    FROM Kit 
                    INNER JOIN Pedido 
                    ON Pedido.id = Kit.pedidoId 
                    WHERE Kit.statusKit = 3 
                    AND Pedido.acerto >= "${initialDate}" 
                    ${sectorId.length > 0 ? `AND Pedido.gerenteSetorId = '${sectorId}' ` : ""}
                    ${agentId.length > 0 ? `AND Pedido.representanteId = '${agentId}' ` : ""}
                    AND Pedido.acerto < "${endDate}"`
                },
            ]
        };

        const response = await api.post<IPartialResponse[]>("reports", body);
        console.log(response);
        return this.GetFromCodeResult(response.data, "Parcial").map(result => {
            return {
                regional: result.Regional,
                setor: result.Setor,
                representante: result.Representante,
                quantidade: result.Qtd,
                totalVendas: result.TotalVendas,
                totalReceber: result.TotalReceber,
                totalRecebido: result.TotalRecebido,
                credDeb: result.CredDeb,
                empresa: result.Empresa,
                faltam: this.GetFromCodeResult(response.data, "Faltam")[0].Faltam
            }
        });
    }

    GetFromCodeResult(data: IPartialResponse[], codeResult: string) {

        return data.find(result => result.codeResult === codeResult)?.data || [];
    }
}

const partialRepository = new PartialRepository();
export default partialRepository;